import {
  Button,
  Link,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  useDisclosure,
} from "@chakra-ui/react";
import { MdInfoOutline } from "react-icons/md";

function InformationalModal(props) {
  const {
    title,
    body,
    variant,
    buttonText,
    secondaryButtonText,
    secondaryButtonLink,
  } = props;

  const { isOpen, onOpen, onClose } = useDisclosure();
  return (
    <>
      {variant === "button" ? (
        <Button onClick={onOpen}>{buttonText}</Button>
      ) : variant === "icon" ? (
        <MdInfoOutline onClick={onOpen} color={"gray"} />
      ) : (
        <Text
          ml={0}
          fontWeight={"bold"}
          color={"teal.500"}
          cursor={"pointer"}
          onClick={onOpen}
        >
          {buttonText}
        </Text>
      )}

      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent mt={200} p={4}>
          <ModalHeader>{title}</ModalHeader>
          <ModalCloseButton />
          <ModalBody>{body}</ModalBody>

          <ModalFooter>
            <Button colorScheme="green" mr={3} onClick={onClose}>
              Close
            </Button>
            {secondaryButtonText && (
              <Button colorScheme="gray" mr={3}>
                <Link href={secondaryButtonLink}>{secondaryButtonText}</Link>
              </Button>
            )}
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}

export default InformationalModal;
